import React from 'react';
import PropTypes from 'prop-types';
import { FormSection } from 'AppSrc/core/components/forms/form-section';
import { prefixStringWithIndexPlusOne } from 'AppSrc/core/utility-functions/string-fun';
import { navigationPropsShape } from 'AppSrc/core/components/forms/section-nav';
import { userRolesPropShape } from 'AppSrc/core/auth/auth-proptypes';
import { COORDINATOR } from 'AppSrc/core/components/forms/form-base-components/data-structure/constants';
import { CHANGE_QUESTIONS } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/section-two';
// Key values that are repeated a lot
import { defaultFieldLogic } from 'AppSrc/core/components/forms/form-base-components/data-structure/default-field-logic';
import {
  formDataShape,
} from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import {
  WORK_INFORMATION_ITEMS,
  SECTION_TITLES,
} from 'AppSrc/core/components/forms/form-types/create-crq/form-definition/section-constants';
import {
  YES_WI_EVIDENCE_ADDED,
  MOBILE,
  FIXED,
} from 'AppSrc/core/components/forms/value-dependency-constants';
import {
  userRoleForSelectedNetwork,
  currentSelectedNetwork,
} from 'AppSrc/core/components/forms/form-types/create-crq/common-logic';
// fields with connected logic
import { testingStatus } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/testing-status';
// form fields
import { workInformationItems } from './work-information-items/work-information-items';



// Section ID (for the data layer)
const sectionId = WORK_INFORMATION_ITEMS;
// Title for the main form
const sectionTitle = SECTION_TITLES[WORK_INFORMATION_ITEMS];


// This is optionally only if the user is a requester and the testingStatus is not 'YES:WI evidence added'
const isWorkInformationItemOptional = ({
  formData,
  userRole,
  selectedNetwork,
}) => {
  // Safe fallback if unable to determine if optional (should hopefully not happen on live)
  const fallBack = false;

  if (userRole === COORDINATOR) {
    return false;
  }

  /* MOBILE specific logic */

  if (selectedNetwork === MOBILE) {
    const changeQuestions = formData.dataByFormSectionId[CHANGE_QUESTIONS];

    if (!changeQuestions) {
      console.warn(`UNABLE TO DETERMINE CHANGE QUESTIONS FROM SECTION TWO, FALLING BACK TO OPTIONAL: ${fallBack}`);
      return fallBack;
    }

    const testingStatusValue = changeQuestions.dataByFieldId[testingStatus.id].value;

    if (testingStatusValue !== null) {
      //
      const optional = testingStatusValue !== YES_WI_EVIDENCE_ADDED;
      return optional;
    }
  }

  /* FIXED specific logic */
  if (selectedNetwork === FIXED) {
    // no logic, just always return true for FIXED
    return true;
  }

  return fallBack;
};


// callback for the form section to figure out what fields to render with conditional logic
const getCurrentFields = (params) => {

  const {
    // values = {},
    formData = {},
    // touched = {},
    userRoles,
  } = params;

  const selectedNetwork = currentSelectedNetwork(formData);
  const userRole = userRoleForSelectedNetwork(formData, userRoles);
  const workInformationItemOptional = isWorkInformationItemOptional({
    formData,
    userRole,
    selectedNetwork,
  });



  const currentFields = [];
  currentFields.push({
    ...defaultFieldLogic,
    componentData: workInformationItems,
    optional: workInformationItemOptional,
  });
  return currentFields;
};

// generates the formSection!
const SectionFive = React.memo(({
  handleSuccessfulSubmit,
  userRoles,
  formData,
  navigationProps,
  sectionIndex,
  editingStatus,
  saveFormSectionErrors,
}) => {
  // Props for the SectionNav in FormSection. these come from the parent but we mutate them to be relivent to the section
  const filteredNavigationProps = {
    ...navigationProps,
    submitForm: null,
  };

  const formattedSectionTitle = prefixStringWithIndexPlusOne(sectionTitle, sectionIndex);

  // coordinators should be allowed to submit the work info items section with workItems still mandatory
  // This is because not all of the information necessary to create them is available when raising a CRQ.
  // Some of the mandatory work items require a POU to have been generated, and this is generated asyncrhonously on TIL
  const userRole = userRoleForSelectedNetwork(formData, userRoles);
  const allowSubmissionWithErrors = userRole === COORDINATOR;

  return (
    <FormSection
      sectionTitle={formattedSectionTitle}
      sectionId={sectionId}
      getCurrentFields={getCurrentFields}
      userRoles={userRoles}
      formData={formData}
      navigationProps={filteredNavigationProps}
      handleSuccessfulSubmit={handleSuccessfulSubmit}
      editingStatus={editingStatus}
      allowSubmissionWithErrors={allowSubmissionWithErrors}
      saveFormSectionErrors={saveFormSectionErrors}
    />
  );
});



SectionFive.propTypes = {
  handleSuccessfulSubmit: PropTypes.func,
  userRoles: userRolesPropShape,
  formData: formDataShape,
  navigationProps: navigationPropsShape,
  sectionIndex: PropTypes.number,
  editingStatus: PropTypes.string,
  saveFormSectionErrors: PropTypes.func,
};

export {
  SectionFive,
  getCurrentFields,
  WORK_INFORMATION_ITEMS,
};
